import React from 'react';

export class TradeHistoryTable extends React.Component 
{

    render (){
        const { list } = this.props ; 

        return (
            list ? (
                <div className="table-container">
                    <table className="table tbl-exchange is-fullwidth m-t-md is-small">
                        <thead className="purple">
                            <tr>
                                <th>Time</th>
                                <th></th>
                                <th>Size</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                list.length > 0 && 
                                list.map((item) => {
                                    return (
                                        <tr>
                                            <td>{item.verificationtimestr}</td>
                                            <td>{item.tradetype}</td>
                                            <td>{item.buyCurrency} {item.amount}</td>
                                            <td>{item.sellCurrency}{item.rate}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            )
            :
            (
                <div></div>
            )
        )
    }
}



// WEBPACK FOOTER //
// ./src/Views/ExchangePage/TradeHistoryTable.jsx